import { useEffect } from 'react';
import { useKeycloak } from "@react-keycloak/web";
import { Link, useParams, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import axios from 'axios';
import { setMenuSelected } from '../redux/actions/menuActions';
import { setFiltering } from '../redux/actions/filteringActions';
import { setDoplnky } from '../redux/actions/prvkyActions';
import Filtering from '../comp/Filtering';
import ListingDoplnku from '../comp/ListingDoplnku';
import URLEndPointBE from '../comp/URLEndPointBE';
import FilteringToggleAdminAll from '../comp/FilteringToggleAdminAll';

function SeznamDoplnku() {
    const { keycloak, initialized } = useKeycloak();
    let { params } = useParams();
    const dispatch = useDispatch();
        //potential succ from insertion/edit redirect
        const {state} = useLocation();
        console.log(state)
    const doplnky = useSelector((state: any) => state.allPrvky.doplnky);
    const filtDoplnky = useSelector((state: any) => state.filtStates.filtDoplnky);
    const visibility = useSelector((state: any) => state.filtStates.visibility);
    const pouziti = useSelector((state: any) => state.miscDicts.pouziti);

    const filtering_list = Object.entries(filtDoplnky).map((filt: any) => (filt[1]===true)&&filt[0])
    
    let pouziti_list_ids = pouziti.filter((pouz: any) => {
        if (visibility === 'NORMAL') {
            return pouz.pouzitibool === 1;
        } else if (visibility === 'ALL') {
            return pouz.pouzitibool === 1 || pouz.pouzitibool === 0;
        }
    })
    .reduce((list: any, pouz: any)=>([...list, pouz.key]),[]);

    let doplnky_filtered = doplnky.filter((dopl: any) => (dopl.doplnkyPouziti!=null)&&(dopl.doplnkyPouziti.some((pouz: any)=> filtering_list.includes(pouz.rodina_kod)&&pouziti_list_ids.includes(pouz.pouziti_id))))
    //TODO rewrite debug to function if doplnky!=[]
    /*
    console.log("<SeznamDoplnku debug of vars")
    console.log("doplnky")
    console.log(doplnky)
    */
    /*
    console.log("filtDoplnky")
    console.log(filtDoplnky)
    console.log("pouziti")
    console.log(pouziti)
    console.log("filtering_list")
    console.log(filtering_list)
    console.log("pouziti_list_ids")
    console.log(pouziti_list_ids)
    console.log("doplnky_filtered")
    console.log(doplnky_filtered)
    console.log("-END-")
    */
    const FetchDoplnky = async () => {
        const response: any = await axios
            .get(URLEndPointBE+`/listing/doplnky`)
            .catch((error) => {
                console.log("Err", error)
            });
        return response.data;    
        //dispatch(setDoplnky(response.data));
    }
    const FetchSetRodinyDoplnku = async () => {
        //rodiny povrchu are same as rodiny doplnku
        const _rodiny_doplnku: any = await axios
            .get(URLEndPointBE+`/dict-misc/rodiny-povrchu`)
            .catch((error) => {
              console.log("Err rodiny povrchu", error)
            });          
        let _rodiny_doplnku_state = _rodiny_doplnku.data.reduce((objVals: any, v: any)=>({...objVals, [v.kod]: true}), {})
        dispatch(setFiltering({flag: "DOPLNKY", filtering: _rodiny_doplnku_state})) 
    }
    const FilteringAllFalseCombined = async (params: any) => {
        const _rodiny_doplnku: any = await axios
            .get(URLEndPointBE+`/dict-misc/rodiny-povrchu`)
            .catch((error) => {
              console.log("Err rodiny povrchu", error)
            });
        let _rodiny_doplnku_state = _rodiny_doplnku.data.reduce((objVals: any, v: any)=>({...objVals, [v.kod]: false}), {})
        for(let p of params) {
            _rodiny_doplnku_state[p]=true;
        }
        dispatch(setFiltering({flag: "DOPLNKY", filtering: _rodiny_doplnku_state}))
    }

    useEffect(() => {
        dispatch(setMenuSelected("doplnky"));

        const doplnky = FetchDoplnky();
        Promise.resolve(doplnky).then((result) => {
            dispatch(setDoplnky(result));
        });

        if(typeof(params) !=='undefined') {
            let opt_params = params.split(';')
            FilteringAllFalseCombined(opt_params)
        } else {
            FetchSetRodinyDoplnku();
        }
    }, [])

    return (
        <Container>
            {/*/@ts-ignore*/}
            {(state?.succ)?<Row className={"succRow"}>
                {/*/@ts-ignore*/}
                <span className={"succTxtInside"}>Úspěch - {state?.type} {state?.item} </span>
            </Row>:<></>}
            <Row className="prvkyControl printHide">
                <Col className='boxBorderAround'>
                    <span className='alignLeft'><h2><b>SEZNAM DOPLŇKŮ</b></h2></span>
                    {keycloak.authenticated && (
                    <Link className="navRemoveUnderscoreInLinkA" to="/doplnky/new">
                        <span className="katBtnStyle">NOVÝ ZÁZNAM</span>
                    </Link>
                    )}
                </Col>
                <Col className='boxBorderAround'>
                    <Filtering caption="VÝBĚR DLE POUŽITÍ" flag="DOPLNKY" param={filtDoplnky}/>
                    { (keycloak.authenticated)
                        ? <FilteringToggleAdminAll visibility={visibility}/>
                        : <></> }
                    
                </Col>
            </Row>
            { (keycloak.authenticated)
              ? <ListingDoplnku doplnky={doplnky_filtered}/>
              : <ListingDoplnku doplnky={doplnky_filtered.filter((dopl: any)=> dopl.viditelnost==1)}/> }
        </Container>
    )
};
export default SeznamDoplnku